import {
  CONTACT_LIST_URL,
  CONTACT_URL,
  HOMEKEEP_CONTACT,
  HOMEKEEP_CONTACT_ID
} from 'core/constants';
import { createApiRequest } from 'core/util';
import type { AppThunk, AppDispatch } from 'core/store';
import {
  createContactStart,
  createContactSuccess,
  createContactError,
  updateContactStart,
  updateContactSuccess,
  updateContactError,
  fetchContactListSuccess,
  fetchContactListError,
  fetchContactStart,
  fetchContactSuccess,
  fetchContactError,
  fetchContactListStart,
  deleteContactError,
  deleteContactStart,
  deleteContactSuccess
} from 'features/shared/contacts/ContactsSlice';

export const fetchContactList = (homeId: number) =>
  createApiRequest({
    route: CONTACT_LIST_URL,
    replace: ['home_id', homeId],
    onStart: fetchContactListStart,
    onSuccess: fetchContactListSuccess,
    onError: fetchContactListError,
    defaultErrorMessage: 'There was a problem loading your contacts.',
    useGlobalLoader: true
  })();

export const fetchContact = (homeId: number, contactId: number) =>
  createApiRequest({
    route: CONTACT_URL,
    replace: [
      ['home_id', homeId],
      ['contact_id', contactId]
    ],
    onStart: fetchContactStart,
    onSuccess: fetchContactSuccess,
    onError: fetchContactError,
    defaultErrorMessage: 'There was a problem loading your contacts.',
    useGlobalLoader: true
  })();

export const createContact = (homeId: number, body: object) =>
  createApiRequest({
    route: CONTACT_LIST_URL,
    method: 'post',
    body: body,
    replace: [['home_id', homeId]],
    onStart: createContactStart,
    onSuccess: createContactSuccess,
    onError: createContactError,
    defaultErrorMessage: 'There was an error updating the product templates.'
  })();

export const updateContact = (
  homeId: number,
  contactId: number,
  body: object
) =>
  createApiRequest({
    route: CONTACT_URL,
    method: 'patch',
    body: body,
    replace: [
      ['home_id', homeId],
      ['contact_id', contactId]
    ],
    onStart: updateContactStart,
    onSuccess: updateContactSuccess,
    onError: updateContactError,
    defaultErrorMessage: 'There was an error updating the product templates.'
  })();

export const deleteContact = (homeId: number, contactId: number) =>
  createApiRequest({
    route: CONTACT_URL,
    method: 'delete',
    replace: [
      ['home_id', homeId],
      ['contact_id', contactId]
    ],
    onStart: deleteContactStart,
    onSuccess: deleteContactSuccess,
    onError: deleteContactError,
    defaultErrorMessage: 'There was a problem loading your contacts.',
    useGlobalLoader: true
  })();

export const fetchContactOrVendor =
  (homeId: number, contactId: number): AppThunk =>
  (dispatch: AppDispatch) => {
    // HOMEKEEP_CONTACT (id 1) is a hardcoded frontend-only entry with no
    // backend record — fetching it would 404. Use the constant directly.
    if (contactId === HOMEKEEP_CONTACT_ID) {
      dispatch(fetchContactStart());
      dispatch(fetchContactSuccess(HOMEKEEP_CONTACT));
      return;
    }
    // The list endpoint (ContactListSchema) omits home_ids; reusing a
    // list-cached contact here left currentContact.home_ids undefined,
    // so contactOwnedByUser always failed the edit-ownership check.
    // Always fetch the single-contact endpoint (ContactSchema), which
    // includes home_ids.
    dispatch(fetchContact(homeId, contactId));
  };
